import { render, staticRenderFns } from "./primary-skills.vue?vue&type=template&id=8ee68706&scoped=true&"
import script from "./primary-skills.vue?vue&type=script&lang=js&"
export * from "./primary-skills.vue?vue&type=script&lang=js&"
import style0 from "./primary-skills.vue?vue&type=style&index=0&id=8ee68706&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee68706",
  null
  
)

export default component.exports